





define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        var displayKeyname = ApiKeyNames.display;

        return function() {
            return {
                copyrightsWorld: requestFactory.single(endpoints.copyrightsWorld, displayKeyname),
                copyrightsBounds: requestFactory.single(endpoints.copyrightsBounds, displayKeyname),

                caption: requestFactory.single(endpoints.caption, displayKeyname)
            };
        };
    }
);



// WEBPACK FOOTER //
// ./rest/copyright.js